import { isEmailValid as checkEmailValidity } from '../../utils/emailValidation';
import { isValidPhoneNumber } from 'libphonenumber-js'
export default
{

    data () {
        return {
            errorInput: false,
            error:{},
            message: null
        }
    },

    methods: {
        isEmailValid(email) {
            return checkEmailValidity(email);
        },

        isPhoneValid(mobile, isdCode) {
            //Default number length check validation for IN and SG
            //using isValidPhoneNumber from libphonenumber-js for other countries number validations
            let phoneRegx = /^\d{10}$/;
            if(isdCode === '+91') {
                return mobile.match(phoneRegx);
            }
            else if(isdCode === '+65') {
                phoneRegx = /^\d{8}$/;
                return mobile.match(phoneRegx);
            }
            else {
                return isValidPhoneNumber(`${isdCode}${mobile}`)
            }
        },

        alphabetValid(val, length){

            let data  = val.trim();
            if( !data || (data.length < length) )
                return false;
            else
                return true;
        },

        resetError() {
            this.errorInput = false;
            this.error = {};
            this.message = null;
        },

    }
};

